import { render } from "./Shareholder.vue?vue&type=template&id=207b03d6&scoped=true"
import script from "./Shareholder.vue?vue&type=script&lang=js"
export * from "./Shareholder.vue?vue&type=script&lang=js"

import "./Shareholder.vue?vue&type=style&index=0&id=207b03d6&lang=less&scoped=true"

import exportComponent from "E:\\heguang\\hotel\\src\\manage\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-207b03d6"]])

export default __exports__